export function formatInt(n: number): string {
  return Math.round(n).toLocaleString('en-US');
}

export function formatCompact(n: number, digits = 2): string {
  const abs = Math.abs(n);
  if (abs >= 1e9) return `${(n / 1e9).toFixed(digits)}B`;
  if (abs >= 1e6) return `${(n / 1e6).toFixed(digits === 2 ? 1 : digits)}M`;
  if (abs >= 1e4) return `${(n / 1e3).toFixed(1)}k`;
  return formatInt(n);
}

export function formatPct(n: number, digits = 1): string {
  return `${n.toFixed(digits)}%`;
}

export function formatRatio(r: number): string {
  if (r < 0.01) return r.toFixed(3);
  return r.toFixed(2);
}

export function formatReleased(iso: string | null): string {
  if (!iso) return 'unconfirmed';
  const d = new Date(`${iso}T00:00:00Z`);
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', timeZone: 'UTC' });
}

export function todayIso(): string {
  return new Date().toISOString().slice(0, 10);
}
